'use client';
import { PlusCircleS } from '@lichtblick/photon/icons/mathematics/plus-circle-s';
import { BorderRadius, BorderWidth, Colors, Duration, DurationAndEasing, Spacing } from '@lichtblick/theme';
import { AccordionTrigger } from '@lichtblick/ui-components/organisms/Accordion/Accordion.styles';
import { Content, Item } from '@radix-ui/react-accordion';
import styled from 'styled-components';
export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Icon = styled(PlusCircleS)`
  margin-left: 0.25rem;
  transition: transform ${DurationAndEasing.LargeOutro};

  .accordion-trigger[data-state='open'] &, ${AccordionTrigger}[data-state='open'] & {
    transform: rotate(45deg);
  }
`;
export const IconWrapper = styled.div`
  line-height: 0;
  width: 2.5rem;
  flex-shrink: 0;
`;
export const CollapsibleContent = styled.div`
  padding: 0 0 ${Spacing.Xs} ${Spacing.L};
`;
export const Root = styled(Item)`
  border-color: ${({ $isThemeFadedGray })=>$isThemeFadedGray ? Colors.White : Colors.FadedGray};
  border-style: solid;
  border-width: ${BorderWidth.Input} 0 0 0;

  &:focus-within {
    position: relative;
    z-index: 1;
    /* Add box-shadow to focus-within if a11y is required */
  }

  &:last-child {
    border-bottom-width: ${BorderWidth.Input};
  }

  .accordion-trigger, ${AccordionTrigger} {
    padding: ${Spacing.Xxs} ${Spacing['3Xs']};
    margin: ${Spacing['3Xs']} 0;
    border-radius: ${BorderRadius.S};

    &:active {
      background: color-mix(in srgb, ${Colors.Black} 11%, transparent);
    }
  }

  @media (hover: hover) {
    & .accordion-trigger:hover, & ${AccordionTrigger}:hover {
      background: color-mix(in srgb, ${Colors.Black} 11%, transparent);
    }
  }
`;
export const StyledContent = styled(Content)`
  padding: 0 !important; /* Do not overwrite. Set padding on children elements. */
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  &[data-state='open'],
  &[data-state='closed'] {
    animation-duration: ${Duration.SmallOutro}ms;
    animation-fill-mode: forwards;
  }

  &[data-state='open'] {
    animation-timing-function: ease-in;
  }
  &[data-state='closed'] {
    animation-timing-function: ease-out;
  }
`;

//# sourceMappingURL=MAccordionItem.styles.js.map